import type { ReactElement } from 'react';
import { PortalDsButton } from 'src/components/portal-design-system';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';

export interface ManageAccountsSyncSuccessDialogProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
}

export function ManageAccountsSyncSuccessDialog({
  open,
  onOpenChange,
}: ManageAccountsSyncSuccessDialogProps): ReactElement {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="rounded-xl border border-[#EDEEF2] bg-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold tracking-[-0.02em] text-[#0D0F1A]">
            Sync started
          </DialogTitle>
          <DialogDescription className="text-[14px] text-[#5E6278]">
            Loading accounts and campaigns — this may take a few minutes. Feel free to navigate away from this page.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <PortalDsButton
            type="button"
            variant="primary"
            size="md"
            onClick={(event) => {
              event.stopPropagation();
              onOpenChange(false);
            }}
          >
            OK
          </PortalDsButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
